import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/utility/context/auth-context'
import type { Acao } from '@/utility/permissions'

export const PrivateRoute = () => {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />
}

export const PublicRoute = () => {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Outlet />
}

export const PermissionRoute = ({ acao }: { acao: Acao }) => {
  const { can } = useAuth()
  return can(acao) ? <Outlet /> : <Navigate to="/dashboard" replace />
}
